import template from './results-summary.html';
import ResultsSummaryController from './results-summary.controller';
import './results-summary.less';

const ResultsSummaryComponent = {
  bindings: {
    data: '<',
    orderByShowNearest: '<',
    filterByExpertType: '<',
    filterByIndustry: '<',
    selectedIndustry: '<',
    showLocationFilter: '<'
  },
  template,
  controller: ResultsSummaryController
};

export default ResultsSummaryComponent;



// WEBPACK FOOTER //
// ./src/components/results-summary/results-summary.component.js